/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    const normalizedProductId = String(productId || '').trim();
    if (!/^\d+$/.test(normalizedProductId)) return;

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== normalizedProductId);
    viewedProducts.unshift(normalizedProductId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch {
      // Product history is optional and must not interrupt storefront browsing.
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch {
      // Product history is optional and must not interrupt storefront browsing.
    }
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      const storedProducts = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      if (!Array.isArray(storedProducts)) return [];

      return [
        ...new Set(
          storedProducts
            .map((productId) => String(productId || '').trim())
            .filter((productId) => /^\d+$/.test(productId))
        ),
      ].slice(0, this.#MAX_PRODUCTS);
    } catch {
      return [];
    }
  }
}
